export default {
  title: 'Carrier Management',

  // Tabs
  tabs: {
    shipping: 'Shipping Companies',
    airline: 'Airlines',
    railway: 'Railway Companies',
    express: 'Express Carriers'
  },

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    shippingPlaceholder: 'Company name, carrier code, SCAC CODE',
    airlinePlaceholder: 'Company name, Chinese/English aliases, IATA code, ICAO code',
    railwayPlaceholder: 'Company name, company code, country, province/state',
    expressPlaceholder: 'Carrier name, carrier code, account number',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addShipping: 'Add Shipping Company',
    addAirline: 'Add Airline',
    addRailway: 'Add Railway Company',
    addExpress: 'Add Express Carrier',
    editExpress: 'Edit Express Carrier',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enableItem: 'Enable',
    disableItem: 'Disable',
    ediSetting: 'EDI Settings',
    weightTierSetting: 'Set Weight Tiers',
    densityGradeSetting: 'Density Grades',
    batchWeightTier: 'Batch Set Weight Tiers',
    batchDensityGrade: 'Batch Set Density Grades',
    recordsCount: 'Total {count} records'
  },

  // Express carrier
  express: {
    accountNos: 'Account Numbers',
    accountNosPlaceholder: 'Separate multiple account numbers with commas',
    serviceTypes: 'Service Types',
    serviceTypePlaceholder: 'Select service types',
    serviceTypeLoadingPlaceholder: 'Loading service types...',
    remark: 'Remark',
    remarkPlaceholder: 'Enter remark',
    saveSuccess: 'Express carrier saved',
    carrierCodeRequired: 'Please enter carrier code',
    carrierCodeAutoPlaceholder: 'Generated after saving',
    nameCnRequired: 'Please enter carrier name (Chinese)',
    serviceTypeRequired: 'Please select service types',
    weightTierTitle: 'Express Weight Tier Settings - {name}',
    weightTierTip: 'Weight tiers are maintained by service type. Tiers within the same service type must be continuous and non-overlapping.',
    weightTierServiceTypeRequired: 'Please select service type',
    weightTierSaveSuccess: 'Express weight tier settings saved'
  },

  // Express service types
  expressServiceType: {
    express: 'Express',
    DHL_EXPRESS_WORLDWIDE: 'DHL Express Worldwide',
    DHL_EXPRESS_WORLDWIDE_EXPORT: 'DHL Express Worldwide Export',
    DHL_EXPRESS_WORLDWIDE_IMPORT: 'DHL Express Worldwide Import',
    DHL_EXPRESS_WORLDWIDE_THIRD_COUNTRY: 'DHL Express Worldwide Third Country',
    standard: 'Standard',
    economy: 'Economy',
    priority_freight: 'Priority Freight',
    economy_freight: 'Economy Freight',
    deferred_freight: 'Deferred Freight'
  },

  // Airline weight tier settings
  weightTier: {
    title: 'Weight Tier Settings - {name}',
    batchTitle: 'Batch Set Weight Tiers',
    batchTip: 'Select a template, adjust its tiers, and apply them to {count} airlines',
    add: 'Add Weight Tier',
    batchAdd: 'Batch Add',
    loadTemplate: 'Load Default Template',
    name: 'Weight Tier Name',
    namePlaceholder: 'e.g. 0-45kg, 1000kg+',
    startWeight: 'Start Weight (kg)',
    endWeight: 'End Weight (kg)',
    unlimited: 'Unlimited',
    range: 'Weight Range',
    step: 'Step (kg)',
    count: 'Count',
    templateCount: '{count} weight tiers',
    templateRequired: 'Please select a weight tier template',
    saveSuccess: 'Weight tier settings saved',
    batchSaveSuccess: 'Batch weight tier settings saved',
    emptyError: 'Weight tier list cannot be empty',
    nameRequired: 'Weight tier name cannot be empty',
    startRequired: 'Start weight cannot be empty',
    firstStartRequired: 'The first start weight must be 0; heavy air template may start from 100',
    endGreaterThanStart: 'End weight must be greater than start weight',
    unlimitedLast: 'Unlimited weight tier must be the last row',
    continuityError: 'Weight tiers must be continuous'
  },

  // Airline density grade settings
  densityGrade: {
    title: 'Density Grade Settings - {name}',
    batchTitle: 'Batch Set Density Grades',
    batchTip: 'The configured density grades will be applied to {count} airlines',
    add: 'Add Density Grade',
    minRatio: 'Start Density (kg/CBM)',
    maxRatio: 'End Density (kg/CBM)',
    unlimited: 'Unlimited',
    range: 'Density Range',
    description: 'Description',
    descriptionPlaceholder: 'Enter description',
    emptyText: 'No density grades. Click "Add Density Grade" to start.',
    saveSuccess: 'Density grade settings saved',
    batchSaveSuccess: 'Batch density grade settings saved',
    emptyError: 'Density grade list cannot be empty',
    minRequired: 'Start density cannot be empty',
    firstMinRequired: 'The first start density must be 0',
    maxGreaterThanMin: 'End density must be greater than start density',
    unlimitedLast: 'Unlimited density grade must be the last row',
    continuityError: 'Density grades must be continuous'
  },

  // Shipping company table columns
  shippingTable: {
    nameCn: 'Company Name (Chinese)',
    nameEn: 'Company Name (English)',
    shortName: 'Short Name',
    carrierCode: 'Carrier Code',
    scacCode: 'SCAC CODE',
    eoriNumber: 'EORI Number',
    code9000: '9000 CODE',
    naccsCode: 'NACCS CODE',
    ediCodes: 'EDI Codes',
    status: 'Status',
    operation: 'Operation',
    codesCount: '{count} codes',
    notSet: 'Not Set'
  },

  // Airline table columns
  airlineTable: {
    nameCn: 'Airline Name (Chinese)',
    nameEn: 'Airline Name (English)',
    nameCnAliases: 'Chinese Aliases',
    nameEnAliases: 'English Aliases',
    shortName: 'Short Name',
    carrierCode: 'Airline Code',
    iataCode: 'IATA 2-Character Code',
    awbPrefix: 'IATA Accounting Code',
    icaoCode: 'ICAO 3-Letter Code',
    prefix: 'PREFIX',
    contact: 'Contact',
    phone: 'Phone',
    status: 'Status',
    operation: 'Operation'
  },

  // Railway company table columns
  railwayTable: {
    nameCn: 'Company Name (Chinese)',
    nameEn: 'Company Name (English)',
    shortName: 'Short Name',
    carrierCode: 'Company Code',
    logo: 'Logo',
    country: 'Country',
    province: 'Province/State',
    status: 'Status',
    operation: 'Operation'
  },

  // Express carrier table columns
  expressTable: {
    nameCn: 'Carrier Name (Chinese)',
    nameEn: 'Carrier Name (English)',
    carrierCode: 'Carrier Code',
    accountNos: 'Account Numbers',
    serviceTypes: 'Service Types',
    remark: 'Remark',
    status: 'Status',
    operation: 'Operation'
  },

  // Platform association modal
  associateModal: {
    shippingTitle: 'Associate Shipping Company',
    airlineTitle: 'Associate Airline',
    railwayTitle: 'Associate Railway Company',
    expressTitle: 'Associate Express Carrier',
    confirmText: 'Confirm Associate ({count})',
    selected: 'Selected {count} {type}, {total} available',
    shippingType: 'shipping companies',
    airlineType: 'airlines',
    railwayType: 'railway companies',
    expressType: 'express carriers'
  },

  // EDI settings modal
  ediModal: {
    title: 'EDI Code Settings',
    platform: 'Platform',
    ediCode: 'EDI Code',
    addCode: 'Add EDI Code',
    deleteCode: 'Delete',
    saveButton: 'Save',
    cancelButton: 'Cancel',
    duplicateWarning: 'Duplicate platform',
    duplicateRowsError: 'Duplicate platform in row(s) {rows}',
    duplicateRowsSaveError: 'Duplicate platform in row(s) {rows}, please fix before saving'
  },

  // Confirmation dialogs
  confirm: {
    enableShipping: 'Are you sure to enable this shipping company?',
    disableShipping: 'Are you sure to disable this shipping company?',
    enableAirline: 'Are you sure to enable this airline?',
    disableAirline: 'Are you sure to disable this airline?',
    enableRailway: 'Are you sure to enable this railway company?',
    disableRailway: 'Are you sure to disable this railway company?',
    enableExpress: 'Are you sure to enable this express carrier?',
    disableExpress: 'Are you sure to disable this express carrier?',
    deleteEdiCode: 'Are you sure to delete this EDI code?'
  },

  // Form validation
  validation: {
    platformRequired: 'Please select {type} to associate',
    ediCodeRequired: 'EDI code cannot be empty',
    platformRequired2: 'Platform cannot be empty'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select {type} to enable',
    selectToDisable: 'Please select {type} to disable',
    selectToAssociate: 'Please select {type} to associate',
    selectAirlineToConfig: 'Please select airlines to configure',
    selectExpressToConfig: 'Please select express carriers to configure',
    loadError: 'Failed to load {type} data, please try again later',
    platformLoadError: 'Failed to load platform data, please try again later',
    associateError: 'Failed to associate {type}, please try again later',
    associateSuccess: 'Successfully associated {count} {type}',
    statusToggleError: 'Failed to toggle status, please try again later',
    statusToggleSuccess: '{type} has been {status}',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchEnableSuccess: 'Enabled {count} {type}',
    batchDisableError: 'Failed to batch disable, please try again later',
    batchDisableSuccess: 'Disabled {count} {type}',
    ediSaveError: 'Failed to save EDI codes, please try again later',
    ediSaveSuccess: 'EDI codes saved successfully',
    ediDeleteError: 'Failed to delete EDI code, please try again later',
    ediDeleteSuccess: 'EDI code deleted successfully'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  }
}
